import { Input as AntInput } from 'antd';
import { TextAreaProps } from 'antd/es/input';

import { BFC } from '@/shared/types';

export const TextArea: BFC<TextAreaProps> = (props) => {
  return <AntInput.TextArea {...props} />;
};
